export const isModalOpen = state => state.modal.openModal;